export default {
  name: "i-footer",
};
